
export const ENSEIGNANT_MES_COURS_INITIATE_FETCH_COURS_RESSOURCES = 'ENSEIGNANT_MES_COURS_INITIATE_FETCH_COURS_RESSOURCES';
export const ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_START = 'ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_START';
export const ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_SUCCESS = 'ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_SUCCESS';
export const ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_FAIL = 'ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_FAIL';
export const ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_RESET = 'ENSEIGNANT_MES_COURS_FETCH_COURS_RESSOURCES_RESET';
